
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";



const extraFunctie = () =>{
    
}



const Cleaningtype = () => {
    const navigate = useNavigate();
    useEffect(() => {
        try {
            const data = async () => {
            };
            data.then(response => {
                if (response === 200) {
                    const contentdiv = document.getElementById("content")
                } else {
                    throw new Error(response.status + ":" + response.message)
                }
            })
        } catch (error) {
            setErrorMessage(error.message)
        }


    }, []);

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="content" className='formwidth'>
                    <form className="form" >
                    <label className='formtitle'>
                                Cleaning type
                            </label>
                        <div className="formchild">
                            <label className='labelhotel'>
                                Id:
                            </label>
                            <input className="normalinput" type='text'  ></input>
                            </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                Name:
                            </label>
                            <input className="normalinput" type='text'  ></input>
                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                Description:
                            </label>
                            <textarea name="message" className="textarea doublegrid"></textarea>
                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                Default tasks:
                            </label>
                            <textarea name="message" className="textarea doublegrid"></textarea>
                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                               Duration:
                            </label>
                            <input className="normalinput" type='text'  ></input>
                        </div>
                        
                    </form>
                </div>
            </div>
        </>
    )

}

export default Cleaningtype